<div class="main-container">
  <app-header></app-header>
  <!-- <app-option-bar></app-option-bar> -->
  <div class="menu-container">
    <!-- <app-side-menu
      [sideMenuVisible]="sideMenuVisible"
      (sendCloseMenu)="getCloseMenu($event)"
      >
    </app-side-menu> -->

    <app-option-bar
      (sendShowMenu)="getShowMenu($event)"
      >
    </app-option-bar>
  </div>

  <div class="content-center">

      <div class="content-1">
        <p class="title">
          Listado de Canales
        </p>
      </div>

      <div class="filter-container">
        <div class="input-container">
          <div hlmField class="gap-1">
            <label hlmFieldLabel for="filtrar">Filtrar:</label>
            <div class="relative w-full">
              <input
                hlmInput
                id="filtrar"
                type="text"
                placeholder="Filtrar"
                [(ngModel)]="filterValue"
                (input)="filterItems($event, 'channels')"
                class="w-full pr-10"
              />
              <i
                class="
                  fa-solid
                  fa-filter
                  absolute
                  right-3
                  top-1/2
                  -translate-y-1/2
                  text-muted-foreground
                "
              ></i>
            </div>
          </div>

        </div>
      </div>

      <div class="table-container">
        <div class="add-channel-container">
          <div>
            Canales
          </div>
          <div>
            <div class="create-channel-btn" (click)="createChannel()" title="Crear un nuevo canal">
              <span class="icon material-symbols-outlined">add_circle</span>
              <span class="text">CREAR CANAL</span>
            </div>
          </div>
        </div>

        <div hlmTableContainer>
          <table hlmTable class="table">
            <thead hlmTableHeader class="header">
              <tr hlmTableRow>
                <th></th>
                <th >
                  <span>
                    Estado
                  </span>
                  <span
                    class="material-symbols-outlined"
                    (click)="changeSort('active')"
                    >
                    swap_vert
                  </span>
                </th>
                <th>
                  <span>
                    Logo
                  </span>
                </th>
                <th>
                  <span>
                    Nombre
                  </span>
                  <span
                    class="material-symbols-outlined"
                    (click)="changeSort('name')"
                  >
                    swap_vert
                  </span>
                </th>
                <th>
                  <span>
                    Marca
                  </span>
                  <span
                    class="material-symbols-outlined"
                    (click)="changeSort('brand')"
                    >
                    swap_vert
                  </span>
                </th>
                <th >
                  <span>
                    Subcanal
                  </span>
                </th>
                <th colspan="2" >
                  <span>
                    Gestión Canal
                  </span>
                </th>
              </tr>
            </thead>
            <tbody hlmTableBody>
              @for (
                item of channelsList;
                track item.id;
                let rowIndex = $index
              ) {
                <tr hlmTableRow>
                  <td hlmTableCell class="center-cell">
                    <input
                      type="checkbox"
                      [(ngModel)]="item.selected"
                      (change)="onItemChange()"
                    >
                  </td>
                  <td hlmTableCell>
                    <span
                      class="circle"
                      [ngStyle]="{'color': getCircleColor(item.active)}"
                    >
                      &#x25CF;
                    </span>
                    {{ item.active == 1 ? 'Activo' : 'Inactivo' }}
                  </td>
                  <td hlmTableCell class="image-cell">
                    <img class="logo" src="{{item.logo}}" alt="no image">
                  </td>
                  <td hlmTableCell>{{ item.name }}</td>
                  <td hlmTableCell class="gray-cells">
                    <button
                      class="btn-action show-sub"
                      (click)="verMarcas(item)"
                      >
                      Ver
                    </button>
                  </td>
                  <td hlmTableCell class="gray-cells">
                    <button
                      class="btn-action show-sub"
                      (click)="verSubcanales(item)"
                      >
                      Ver
                    </button>
                  </td>
                  <td hlmTableCell class="gray-cells">
                    <button class="btn-action" (click)="verDatos(item)">
                      <span>
                        Ver
                      </span>
                    </button>
                  </td>
                  <td hlmTableCell class="gray-cells">
                    @if (item.active) {
                      <button
                        class="btn-action"
                        (click)="setActive(item, false)"
                        >
                        <span>
                          Desactivar
                        </span>
                      </button>
                    }
                    @if (!item.active) {
                      <button
                        class="btn-action"
                        (click)="setActive(item, true)"
                      >
                        <span>
                          Activar
                        </span>
                      </button>
                    }
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
        @if (activityButtons) {
          <div class="activiy-buttons-container">
            <button
              class="button-group"
              (click)="setMultipleActive(true)"
              >
              ACTIVAR
            </button>
            <button
              class="button-group"
              (click)="setMultipleActive(false)"
              >
              DESACTIVAR
            </button>
          </div>
        }

        <div class="main-paginator">
          <div class="paginator-container">
            <hlm-numbered-pagination
              [currentPage]="currentPage"
              [itemsPerPage]="filterRecords"
              [totalItems]="totalRecords"
              [pageSizes]="rowsPerPageOptions"
              (currentPageChange)="onPageChange($event)"
              (itemsPerPageChange)="onItemsPerPageChange($event)"
              class="w-450[px]"
            >

            </hlm-numbered-pagination>
          </div>
        </div>

      </div>

  </div>


  <app-footer class="footer"></app-footer>

</div>
